<template>
  <div>
    <!-- 内容展示页 开始 -->
    <div class="LT-PageBody-wrap">
      <div class="container clearfix">
        <div class="LT-PageBody-main">
          <h2 class="body-title">
            <span class="title-h2">{{ newsInfo.categoryName }}</span>
          </h2>
          <div class="ctd-article-items">
            <div class="article-bd" id="content" v-html="newsInfo.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      newsInfo: {
        categoryName: "加载中......",
        content: "加载中......",
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getNewDetail();
    }
  },
  mounted() {},
  watch: {
    $route() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getNewDetail();
      }
    },
  },
  methods: {
    getNewDetail() {
      let _this = this;
      let parmas = {
        id: _this.id,
        // Authentication: _this.$cookies.get(_this.$commons.User.Authentication),
      };
      _this.$api.news
        .getById(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.newsInfo = res.data;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
/* .detail p{
  line-height: 1.75em !important;

} */
</style>



// WEBPACK FOOTER //
// src/view/news/newsDetail.vue